export const BROKER_WIDGET_MANIFEST_CONFIG_KEY = 'brokerWidgetManifest';

export const FOOTER_CONFIG_KEYS = {
  CIAN_DEAL_TELEGRAM: 'e2e-deal-sale.cianDealTelegram',
  CIAN_PROFESSIONALS_TELEGRAM: 'e2e-deal-sale.cianProfessionalsTelegram',
  PARTNER_REWARDS_CUSTOMER_SUPPORT_CONTACT_PHONE: 'partner-rewards.customerSupportContactPhone',
  PARTNER_REWARDS_CUSTOMER_SUPPORT_CONTACT_EMAIL: 'partner-rewards.customerSupportContactEmail',
  NEW_YEAR_ALERT_ENABLED: 'e2e-deal-sale.newYearAlert.Enabled',
  TRANSACTION_COMMON_FOOTER_DATA: 'transaction.commonFooterData',
};
